// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import CrownOutlined from '/home/runner/work/luxsol-order-system-customer/luxsol-order-system-customer/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import ShoppingOutlined from '/home/runner/work/luxsol-order-system-customer/luxsol-order-system-customer/node_modules/@ant-design/icons/es/icons/ShoppingOutlined';
export default { CrownOutlined, ShoppingOutlined };
